import { render } from "./FriendsSetting.vue?vue&type=template&id=b3b416d8&scoped=true"
import script from "./FriendsSetting.vue?vue&type=script&lang=js"
export * from "./FriendsSetting.vue?vue&type=script&lang=js"

import "./FriendsSetting.vue?vue&type=style&index=0&id=b3b416d8&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b416d8"]])

export default __exports__